import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { reqResInterceptor } from './intercepter/req-res.interceptor';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { API_BASE_URL } from './state-management/api.token';
import { environment } from '../environment/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideHttpClient(withInterceptors([reqResInterceptor])),
    // provideNoopAnimations() used to be registered after this and won,
    // silently disabling all Material/CDK animations (REDESIGN_PLAN Phase 1).
    provideAnimations(),
    DatePipe,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatTooltipModule,
    { provide: API_BASE_URL, useValue: environment.url },
  ]
};
